import type { AttachmentPdfSignaturePlacement } from '@blocksuite/affine/model';

export const PDF_SIGNATURE_PLACEMENT_CLIPBOARD_MIME =
  'application/x-streamlain-pdf-signature-placement+json';

type PdfSignaturePlacementClipboardPayload = {
  kind: 'streamlain-pdf-signature-placement';
  version: 1;
  placement: Pick<
    AttachmentPdfSignaturePlacement,
    'signatureAppearanceId' | 'pageIndex' | 'rect' | 'rotation'
  >;
};

export function writePdfSignaturePlacementClipboard(
  clipboardData: Pick<DataTransfer, 'setData'>,
  placement: AttachmentPdfSignaturePlacement
) {
  const payload: PdfSignaturePlacementClipboardPayload = {
    kind: 'streamlain-pdf-signature-placement',
    version: 1,
    placement: {
      signatureAppearanceId: placement.signatureAppearanceId,
      pageIndex: placement.pageIndex,
      rect: placement.rect,
      rotation: placement.rotation,
    },
  };
  clipboardData.setData(
    PDF_SIGNATURE_PLACEMENT_CLIPBOARD_MIME,
    JSON.stringify(payload)
  );
}

export function readPdfSignaturePlacementClipboard(
  clipboardData: Pick<DataTransfer, 'getData'>
): PdfSignaturePlacementClipboardPayload['placement'] | null {
  const raw = clipboardData.getData(PDF_SIGNATURE_PLACEMENT_CLIPBOARD_MIME);
  if (!raw) return null;
  try {
    const payload = JSON.parse(
      raw
    ) as Partial<PdfSignaturePlacementClipboardPayload>;
    const placement = payload.placement;
    if (
      payload.kind !== 'streamlain-pdf-signature-placement' ||
      payload.version !== 1 ||
      !placement ||
      typeof placement.signatureAppearanceId !== 'string' ||
      !placement.signatureAppearanceId ||
      !Number.isInteger(placement.pageIndex) ||
      typeof placement.rotation !== 'number' ||
      !Number.isFinite(placement.rotation) ||
      !placement.rect ||
      !['x', 'y', 'width', 'height'].every(
        key =>
          typeof placement.rect?.[key as keyof typeof placement.rect] ===
            'number' &&
          Number.isFinite(
            placement.rect[key as keyof typeof placement.rect] as number
          )
      )
    ) {
      return null;
    }
    return placement as PdfSignaturePlacementClipboardPayload['placement'];
  } catch {
    return null;
  }
}
